import React from 'react';
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Services from '../../utils/Services';
import Notification from '../../utils/Notification';

class ArchiveProjectDialog extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.saveArchive = this.saveArchive.bind(this);
    this.cancelArchive = this.cancelArchive.bind(this);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    const { modal } = this.state;
    this.setState({
      modal: !modal,
    });
  }

  saveArchive(e) {
    e.preventDefault();
    const { project, status } = this.props;

    const newProjectData = {
      id: project.id,
      status: status,
    };

    Services.updateStatusProject(newProjectData)
      .then(() => {
        const { afterArchiveProject } = this.props;
        Notification.pushSuccess(`The project ${project.id} archived.`);
        if (afterArchiveProject) {
          afterArchiveProject();
        }
        this.toggle();
      })
      .catch(() => {
        this.toggle();
      });
  }

  cancelArchive() {
    this.toggle();
  }

  render() {
    const { project } = this.props;

    if (project) {
      return (
        <div>
          <Modal isOpen={this.state.modal} toggle={this.toggle}>
            <Form data-trackid="archive-project" onSubmit={this.saveArchive}>
              <ModalHeader>Archive the project</ModalHeader>
              <ModalBody>
                <p>
                  Are you sure you want to archive the{' '}
                  <strong>{project.name}</strong> project?
                </p>
                <p>
                  You will no longer be
                  able to view test results in the project once it has been
                  archived.
                </p>
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={this.cancelArchive}>
                  Cancel
                </Button>
                <Button type="submit" color="danger">
                  Archive This Project
                </Button>
              </ModalFooter>
            </Form>
          </Modal>
        </div>
      );
    }
    return null;
  }
}

export default ArchiveProjectDialog;
